import {
  initialState,
  Actions,
  State,
  GET_ALL_SLIDESHOWS,
  GET_ALL_SLIDESHOWS_ERROR,
  GET_ALL_SLIDESHOWS_SUCCESS,
  GET_SLIDESHOW,
  GET_SLIDESHOW_ERROR,
  GET_SLIDESHOW_SUCCESS,
  NEW_SLIDESHOW,
  NEW_SLIDESHOW_ERROR,
  NEW_SLIDESHOW_SUCCESS,
  RESET_NEW_SLIDESHOW,
  UPDATE_SLIDESHOW,
  UPDATE_SLIDESHOW_ERROR,
  UPDATE_SLIDESHOW_SUCCESS,
  RESET_UPDATE_SLIDESHOW,
  DELETE_SLIDESHOW,
  DELETE_SLIDESHOW_ERROR,
  DELETE_SLIDESHOW_SUCCESS,
  RESET_DELETE_SLIDESHOW,
  UPLOAD_MEDIA,
  UPDATE_SLIDESHOW_LOADING,
  RESET_GET_SLIDESHOW,
  ADD_USER_TO_SLIDESHOW,
  SHARED_SLIDESHOW,
  SET_GET_SLIDESHOW,
  RESET_UPDATE_MANY_SLIDESHOW,
  UPDATE_MANY_SLIDESHOW,
  UPDATE_MANY_SLIDESHOW_ERROR,
  UPDATE_MANY_SLIDESHOW_SUCCESS,
  RESET_GET_ALL_SLIDESHOW_DATA,
} from "../types/slideshow";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_SLIDESHOWS:
      return {
        ...state,
        all: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case GET_ALL_SLIDESHOWS_SUCCESS:
      return {
        ...state,
        all: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case GET_ALL_SLIDESHOWS_ERROR:
      return {
        ...state,
        all: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_GET_ALL_SLIDESHOW_DATA:
      return {
        ...state,
        all: initialState.all,
      };
    case UPDATE_MANY_SLIDESHOW:
      return {
        ...state,
        updateMany: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case UPDATE_MANY_SLIDESHOW_SUCCESS:
      return {
        ...state,
        updateMany: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case UPDATE_MANY_SLIDESHOW_ERROR:
      return {
        ...state,
        updateMany: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_UPDATE_MANY_SLIDESHOW:
      return {
        ...state,
        updateMany: initialState.updateMany,
      };
    case UPLOAD_MEDIA:
      return {
        ...state,
        update: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };

    case ADD_USER_TO_SLIDESHOW:
      return {
        ...state,
        update: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case SHARED_SLIDESHOW:
      return {
        ...state,
        update: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case UPDATE_SLIDESHOW_LOADING:
      return {
        ...state,
        new: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case GET_SLIDESHOW:
      return {
        ...state,
        slideshow: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case GET_SLIDESHOW_SUCCESS:
      return {
        ...state,
        slideshow: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case GET_SLIDESHOW_ERROR:
      return {
        ...state,
        slideshow: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case NEW_SLIDESHOW:
      return {
        ...state,
        new: {
          ...state.new,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case NEW_SLIDESHOW_SUCCESS:
      return {
        ...state,
        new: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case SET_GET_SLIDESHOW:
      return {
        ...state,
        slideshow: {
          ...state.slideshow,
          data: !!action.payload ? action.payload : null,
        },
      };
    case RESET_GET_SLIDESHOW:
      return {
        ...state,
        slideshow: {
          ...state.slideshow,
          states: {
            success: false,
            loading: false,
            error: false,
          },
        },
      };
    case NEW_SLIDESHOW_ERROR:
      return {
        ...state,
        new: {
          ...state.new,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_NEW_SLIDESHOW:
      return {
        ...state,
        new: {
          data: state.new.data,
          states: {
            loading: false,
            error: false,
            success: false,
          },
        },
      };
    case DELETE_SLIDESHOW:
      return {
        ...state,
        delete: {
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case DELETE_SLIDESHOW_SUCCESS:
      return {
        ...state,
        delete: {
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case DELETE_SLIDESHOW_ERROR:
      return {
        ...state,
        delete: {
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_DELETE_SLIDESHOW:
      return {
        ...state,
        delete: initialState.delete,
      };
    case UPDATE_SLIDESHOW:
      return {
        ...state,
        update: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case UPDATE_SLIDESHOW_SUCCESS:
      return {
        ...state,
        update: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case UPDATE_SLIDESHOW_ERROR:
      return {
        ...state,
        update: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_UPDATE_SLIDESHOW:
      return {
        ...state,
        update: initialState.update,
      };
    default:
      return state;
  }
};

export default reducers;
